import { DESKTOP, TABLET } from '@/assets/javascript/responsive/enums'
import { ONE_LINE } from '@/components/section-layouts/enums'
import { LOOPED } from '@/components/slider/sliders'

const BannerSettings = {
  sliderType: LOOPED,
  delayPerSlide: 500,
  slideBufferPerSideSize: 0,
  autoplay: { delay: 5000 },
  hideArrows: true
}

const SliderStrategy = {
  [ONE_LINE]: {
    [TABLET]: {
      itemsPerSlide: 3,
      slideBufferPerSideSize: 1
    },
    [DESKTOP]: {
      itemsPerSlide: 6,
      slideBufferPerSideSize: 1
    }
  }
}

export function optionsGetter (layout) {
  const options = SliderStrategy[layout] || BannerSettings
  return (breakpoint) => options[breakpoint] || options
}
